export type SidebarSection =
  | 'dashboard'
  | 'clients'
  | 'transactions'
  | 'add-transactions'
  | 'rfi'
  | 'investigations'
  | 'calculator'
  | 'security'
  | 'user-actions'
  | 'roles-permissions'
  | 'business-info'
  | 'virtual-account'
  | 'settings'
  | 'notifications'
  | '';

export interface SearchNavigationQueryParams {
  searchOrigin: '1';
  originSection: SidebarSection;
  returnUrl: string;
}

export function buildSearchNavigationQueryParams(currentUrl: string): SearchNavigationQueryParams {
  return {
    searchOrigin: '1',
    originSection: getSidebarSectionFromUrl(currentUrl),
    returnUrl: currentUrl,
  };
}

export function getSidebarSectionFromUrl(url: string): SidebarSection {
  const [pathWithoutQuery] = url.split('?');
  const segments = pathWithoutQuery.split('/').filter(Boolean);
  const firstSegment = segments[0] ?? '';

  switch (firstSegment) {
    case 'dashboard':
    case 'clients':
    case 'transactions':
    case 'add-transactions':
    case 'rfi':
    case 'investigations':
    case 'calculator':
    case 'security':
    case 'user-actions':
    case 'roles-permissions':
    case 'business-info':
    case 'virtual-account':
    case 'settings':
    case 'notifications':
      return firstSegment;
    default:
      return '';
  }
}
